import { FramingSelections } from '../../components/Checkout/Framing/types';
import { CurrencyCode } from '../../types/Locations';
import { AttributeInput } from '../../types/Purchasing';
import { CheckoutOrderTotals } from './utils/orderTotals';
import { CheckoutWork } from './utils/workView';

export const CHECKOUT_STEPS = [
  'works',
  'details',
  'review',
  'success',
] as const;

export type CheckoutStep = (typeof CHECKOUT_STEPS)[number];

export type CheckoutFlowType = 'draw' | 'preOrder' | 'fcfs' | 'timed';

export type CheckoutIntentKind = 'linked' | 'single';

export type CheckoutEntrySelection = {
  framingSelections: FramingSelections;
  maxQuantity: number;
  selectedDraws: string[];
};

export type CheckoutSelectionChange = Partial<
  Pick<CheckoutEntrySelection, 'maxQuantity' | 'selectedDraws'>
>;

export type CheckoutWorksController = {
  enteredWorkIds: string[];
  selectedWorkIds: string[];
  toggleWork: (
    productId: string,
    quantity?: number,
  ) => CheckoutSelectionChange | null;
  works: CheckoutWork[];
};

export type CheckoutEntryDetails = {
  currencyCode: CurrencyCode;
  customAttributes: AttributeInput[];
  paymentMethodId: string | null;
  preOrder: boolean;
  shippingAddressId: string | null;
};

export type CheckoutEntryController = {
  clientSecret: string | null;
  confirmEntry: (intentId: string) => Promise<boolean>;
  confirming: boolean;
  covers: (selection: CheckoutEntrySelection) => boolean;
  error: boolean;
  intentId: string | null;
  loading: boolean;
  quote: CheckoutOrderTotals | null;
  quoteCurrencyCode: string | null;
  reset: () => void;
  submit: (
    selection: CheckoutEntrySelection,
    details: CheckoutEntryDetails,
  ) => Promise<boolean>;
};
